import { render, staticRenderFns } from "./FloatingWhatsapp.vue?vue&type=template&id=3baf4f0f&scoped=true&"
import script from "./FloatingWhatsapp.vue?vue&type=script&lang=ts&"
export * from "./FloatingWhatsapp.vue?vue&type=script&lang=ts&"
import style0 from "./FloatingWhatsapp.vue?vue&type=style&index=0&id=3baf4f0f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.10.1_mi7kfaeh4nmupiqclubmvzt3ru/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3baf4f0f",
  null
  
)

export default component.exports